import React from 'react'
import styles from './advanced-era.scss'
import product from '../../../common/images/product/product-9.jpg'

const AdvancedEra = (props) => {
  return <section className={styles['advanced']}>
    <div className={styles['advanced-contnet']}>
      <div className={styles['product']}>
        <img src={product} alt='product' />
        <div>
          <h3>概而论云记账</h3>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['characters']}>
        <h2>高级代账版</h2>
        <div>
          <p><span>适用群体</span></p>
          <p>对客户管理、企业内部管理要求较高的</p>
          <p>中大型财税服务机构</p>
        </div>
      </div>
      <div className={styles['advanced-table']}>
        <table border='0' cellSpacing='0' cellPadding='0' align='center' width='100%'>
          <tbody>
            <tr className={styles['table-th']}>
              <th>产品版本</th>
              <th colSpan='3'>主要功能</th>
            </tr>
            <tr>
              <td rowSpan='20' className={styles['advanced-gaoji']}><span>高级代账版</span></td>
              <td>多用户</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td>组织架构</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td>授权管理</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td rowSpan='4' className={styles['advanced-center']}>客户管理</td>
              <td colSpan='2' className={styles['advanced-left']}>接洽单、工商服务</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>客户管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>合同管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>收费管理</td>
            </tr>
            <tr>
              <td>人事管理</td>
              <td colSpan='2' className={styles['advanced-left']}>人员全流程管理，合同及档案管理</td>
            </tr>
            <tr>
              <td>报销管理</td>
              <td colSpan='2' className={styles['advanced-left']}>云报销，报销生单</td>
            </tr>
            <tr>
              <td>印章管理</td>
              <td colSpan='2' className={styles['advanced-left']}>印章保管，用印、外借申请</td>
            </tr>
            <tr>
              <td>薪酬管理</td>
              <td colSpan='2' className={styles['advanced-left']}>财税服务公司工资提成、工资审批</td>
            </tr>
            <tr>
              <td rowSpan='9' className={styles['advanced-center']}>智能财务管理</td>
              <td colSpan='2' className={styles['advanced-left']}>基础财务</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票批量获取、电票采集</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票、对账单智能生成凭证</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>工资管理、代账收入生单</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>期末成本自动结转、电子归档</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>存货管理，出入库单、收发存报表</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>财务报表申报、个税申报</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>小程序代账端、老版端（含协同）</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>财务报告（年度、月度）</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles['advanced-yd']}>
        <p><span>适用群体</span></p>
        <p>对客户管理、企业内部管理要求较高的中大</p>
        <p>型财税服务机构</p>
      </div>
    </div>
  </section>
}

export default AdvancedEra
